module.exports = __webpack_public_path__ + "img/expert-6.7cfe257f.png";